import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./components/landingPage";
import HomePage from './components/homePage';
import VinoPage from "./components/vinoPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/projects/vino" element={<VinoPage />} />
      </Routes>
    </Router>
  );
}

export default App;